import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { StorageService } from 'src/app/services/storage/storage.service';
import { CommonService } from 'src/app/services/common/common.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { APP_CONSTANTS } from 'src/app/constants/constants';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';


@Component({
	selector: 'app-individual-activity-details',
	templateUrl: './individual-activity-details.component.html',
	styleUrls: ['./individual-activity-details.component.scss']
})
export class IndividualActivityDetailsComponent implements OnInit {
	APP_CONSTANTS = APP_CONSTANTS;

	user_details: any;
	user_role: any = "";

	previous_url: string = '';
  	current_url: string = '';

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private storageService: StorageService,
		private commonService: CommonService,
		private dialog: MatDialog,
		private domSanitizer: DomSanitizer,
		private datePipe: DatePipe,
	) {

	}

	ngOnInit(): void {

		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 3) {
			this.user_role = "Executive";
		} else if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Leadership";
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
		}

		this.previous_url = history.state.previousRoute;

		this.route.params.subscribe((params) => {
			this.activity_type = params['activity_type'];
			this.activity_id = params['activity_id'];
		});

		// setTimeout(() => {
		// 	this.segregateActivityData();
		// }, 500);

		if (this.activity_type && this.activity_id) {
			this.getActivityData();
		}

		this.getStatusList();
		this.getCommunicationTypes();
		this.getTaggingUsers();
		this.getResponseOptions();
		this.getAFA();

		this.getObjectives();
		this.getProducts();
		this.getConversionStatusList();
		this.getAttritionReasons();

	}

	page_data_loaded: boolean = false;
	activity_type: any;
	activity_id: any;
	activity_data: any;
	activity_data_loaded: boolean = false;

	getActivityData() {
		this.activity_data_loaded = false;
		let route: any = "";
		if (this.activity_type == 'csa') {
			route = "/clientsalesactivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'lpa') {
			route = "/leadprospectactivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'ama') {
			route = "/advisormanageractivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'Executive') {
			route = "/internalactivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'Leadership') {
			route = "/recruiteractivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'Marketing Team') {
			route = "/internalactivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'Branch') {
			route = "/internalactivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'Product') {
			route = "/internalactivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'Advisor Manager') {
			route = "/internalactivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'Advisor') {
			route = "/internalactivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'wa') {
			route = "/wholesaleractivity/" + this.activity_id + "/";
		} else if (this.activity_type == 'ra') {
			route = "/recruiteractivity/" + this.activity_id + "/";
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.activity_data = res;

				if (this.activity_data.scheduled_date != "" && this.activity_data.scheduled_date != null) {
					// this.activity_data.scheduled_date = this.datePipe.transform(this.activity_data.scheduled_date, "MM/dd/yyyy");
					this.activity_data.scheduled_date = new Date(this.activity_data.scheduled_date);
				} else {
					this.activity_data.scheduled_date = "";
				}

				if (this.activity_data.actual_date != "" && this.activity_data.actual_date != null) {
					this.activity_data.actual_date = new Date(this.activity_data.actual_date);
				} else {
					this.activity_data.actual_date = "";
				}

				this.activity_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	status_list: any = [];
	getStatusList() {
		this.commonService.getData('/status/?no_page=true').subscribe(
			(res: any) => {
				this.status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	communication_type_list: any = [];
	getCommunicationTypes() {
		this.commonService.getData('/communicationType/?no_page=true').subscribe(
			(res: any) => {
				this.communication_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	tagging_users_list: any = [];
	getTaggingUsers() {
		this.commonService.getData("/taguserslist/").subscribe(
			(res: any) => {
				this.tagging_users_list = res;
			},
			(err) => {
				this.commonService.showToast("error", err.error);
			}
		)
	}

	response_options_list: any = [];
	getResponseOptions() {
		this.commonService.getData('/responseoption/?no_page=true').subscribe(
			(res: any) => {
				this.response_options_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	afa_list: any = [];
	getAFA() {
		this.commonService.getData('/getassistants').subscribe(
			(res: any) => {
				this.afa_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	segregateActivityData() {
		if (this.activity_type && this.activity_id) {
			this.activity_data = {
				source: this.activity_type,
				id: this.activity_id,
			};
		} else {
			this.activity_data = {
				id: this.activity_id,
			};
		}

		this.page_data_loaded = true;
	}

	activityDetailsClosed(event) {
		if (this.previous_url) {
			this.router.navigateByUrl(this.previous_url);
		} else {
			if (this.user_details.role.role == 1) {
				this.router.navigate(['/admin/dashboard']);
			} else if (this.user_details.role.role == 2) {
				this.router.navigate(['/admin/dashboard']);
			} else if (this.user_details.role.role == 3) {
				// this.router.navigate(['/executive/my-portfolio']);
				this.router.navigate(['/executive/dashboard']);
			} else if (this.user_details.role.role == 4) {
				this.router.navigate(['/advisor-manager']);
			} else if (this.user_details.role.role == 5) {
				this.router.navigate(['/advisor']);
			} else if (this.user_details.role.role == 6) {
				this.router.navigate(['/afa']);
			} else if (this.user_details.role.role == 7) {
				this.router.navigate(['/assistant']);
			} else if (this.user_details.role.role == 8) {
				this.router.navigate(['/relationship-manager']);
			} else if (this.user_details.role.role == 10) {
				// this.router.navigate(['/leadership/my-portfolio']);
				this.router.navigate(['/leadership/dashboard']);
			} else if (this.user_details.role.role == 11) {
				// this.router.navigate(['/marketing-team']);
				this.router.navigate(['/opportunity']);
			} else if (this.user_details.role.role == 12) {
				this.router.navigate(['/wholesaler']);
			} else if (this.user_details.role.role == 13) {
				this.router.navigate(['/lending-officer']);
			} else if (this.user_details.role.role == 14) {
				this.router.navigate(['/insurance-agent']);
			}
		}
	}

	back() {
		if (this.previous_url) {
			this.router.navigateByUrl(this.previous_url);
		} else {
			if (this.user_details.role.role == 1) {
				this.router.navigate(['/admin/dashboard']);
			} else if (this.user_details.role.role == 2) {
				this.router.navigate(['/admin/dashboard']);
			} else if (this.user_details.role.role == 3) {
				// this.router.navigate(['/executive/my-portfolio']);
				this.router.navigate(['/executive/dashboard']);
			} else if (this.user_details.role.role == 4) {
				this.router.navigate(['/advisor-manager']);
			} else if (this.user_details.role.role == 5) {
				this.router.navigate(['/advisor']);
			} else if (this.user_details.role.role == 6) {
				this.router.navigate(['/afa']);
			} else if (this.user_details.role.role == 7) {
				this.router.navigate(['/assistant']);
			} else if (this.user_details.role.role == 8) {
				this.router.navigate(['/relationship-manager']);
			} else if (this.user_details.role.role == 10) {
				// this.router.navigate(['/leadership/my-portfolio']);
				this.router.navigate(['/leadership/dashboard']);
			} else if (this.user_details.role.role == 11) {
				// this.router.navigate(['/marketing-team']);
				this.router.navigate(['/opportunity']);
			} else if (this.user_details.role.role == 12) {
				this.router.navigate(['/wholesaler']);
			} else if (this.user_details.role.role == 13) {
				this.router.navigate(['/lending-officer']);
			} else if (this.user_details.role.role == 14) {
				this.router.navigate(['/insurance-agent']);
			}
		}
	}

	toggleCard(id) {
		const card: any = document.getElementById(id);
		card.classList.toggle('collapsed');
	}

	comment: any = "";
	comment_error: boolean = false;

	comment_loader: boolean = false;
	addComment() {
		if (this.comment != "" && this.comment != null) {
			this.comment_error = false;
		} else {
			this.comment_error = true;
		}

		if (
			this.comment_error == false
		) {
			let route: any = "";
			let payload: any = {
				comment_date: moment(new Date()).format(),
				description: this.comment,
				commented_by: this.user_details.id
			};
			if (this.user_role == "Advisor Manager") {
				route = '/advisormanageractivitycomments/';

				payload.advisormanageradvisor_activity = this.activity_data.id;
			} else if (this.user_role == "Executive") {
				route = '/internalactivitycomments/';
				payload.internal_activity = this.activity_data.id;
			} else if (this.user_role == "Leadership") {
				route = '/internalactivitycomments/';
				payload.internal_activity = this.activity_data.id;
			} else if (this.user_role == "Marketing Team") {
				route = '/internalactivitycomments/';
				payload.internal_activity = this.activity_data.id;
			} else {
				if (this.activity_data.source == 'csa') {
					route = "/clientsalesactivitycomments/";
					payload.clientsales_activity = this.activity_data.id;
				} else if (this.activity_data.source == 'lpa') {
					route = "/leadprospectactivitycomments/";
					payload.prospect_activity = this.activity_data.id;
				}
			}

			this.comment_loader = true;

			this.commonService.postData(route, payload).subscribe(
				(res: any) => {
					this.activity_data.comments.push(res);
					this.comment = "";
					this.comment_error = false;
					this.commonService.showToast('success', 'Comment Added Successfully.');

					this.comment_loader = false;
				},
				(err) => {
					this.commonService.showToast('error', err.error);

					this.comment_loader = false;
				},
			);

		}

	}

	attachment_data: any = {
		attachment_filename: "",
		attachment_file: "",
	};
	attachment_data_errors: any = {
		attachment_filename: false,
		attachment_file: false,
	};

	task_attachment_loader: boolean = false;

	uploadAttachment(event) {
		this.attachment_data.attachment_file = event.target.files[0];
		this.attachment_data.attachment_filename = event.target.files[0].name;

		let form_data: any = new FormData();

		form_data.append("attachment_filename", this.attachment_data.attachment_filename);
		form_data.append("comments", "");
		// form_data.append("comments", this.attachment_data.comments);

		if (typeof (this.attachment_data.attachment_file) != "string") {
			form_data.append("attachment_file", this.attachment_data.attachment_file);
		}

		if (this.activity_data.source == 'csa') {
			form_data.append("csa_id", this.activity_data.id);
		} else if (this.activity_data.source == 'lpa') {
			form_data.append("lpa_id", this.activity_data.id);
		} else if (this.activity_data.source == 'ama') {
			form_data.append("ama_id", this.activity_data.id);
		}else if (this.activity_data.source == 'Executive') {
			form_data.append("int_id", this.activity_data.id);
		} else if (this.activity_data.source == 'Leadership') {
			form_data.append("int_id", this.activity_data.id);
		} else if (this.activity_data.source == 'Marketing Team') {
			form_data.append("int_id", this.activity_data.id);
		} else if (this.activity_data.source == 'Branch') {
			form_data.append("int_id", this.activity_data.id)
		} else if (this.activity_data.source == 'Product') {
			form_data.append("int_id", this.activity_data.id)
		} else if (this.activity_data.source == 'Advisor Manager') {
			form_data.append("int_id", this.activity_data.id)
		} else if (this.activity_data.source == 'Advisor') {
			form_data.append("int_id", this.activity_data.id)
		}

		this.task_attachment_loader = true;

		this.commonService.postData("/taskAttachment/", form_data).subscribe(
			(res: any) => {
				this.activity_data.attachments.push(res);
				this.attachment_data = {
					attachment_filename: "",
					attachment_file: "",
				};
				this.attachment_data_errors = {
					attachment_filename: false,
					attachment_file: false,
				};
				this.commonService.showToast('success', 'Attachment Added Successfully.');

				this.task_attachment_loader = false;

			},
			(err) => {
				this.commonService.showToast('error', err.error);

				this.task_attachment_loader = false;
			},
		);

	}

	download(link) {
		window.open(environment.apiEndpoint + "/" + link, "_blank");
	}

	validateFields(fields, data, errors_data) {
		let has_invalid_fields = false;

		// Safety check: ensure data and errors_data exist
		if (!data) data = {};
		if (!errors_data) errors_data = {};

		fields.forEach((field) => {
			const value = data[field];

			const isInvalid = value === null || value === undefined || value === '';
			errors_data[field] = isInvalid;
			
			if (isInvalid) {
				has_invalid_fields = true;
			}
		});
		return !has_invalid_fields;
	}

	activity_data_errors: any;
	activity_save_loader: boolean = false;
	saveActivityData() {
		let fields: any = ["name", "communication_type", "status", "scheduled_date"];

		if (this.user_role == "Advisor" || this.user_role == "AFA") {
			fields = ["name", "communication_type", "status", "scheduled_date"];
		}

		let invalid_follow_up_tasks: boolean = false;
		if (this.follow_up_task_type != "") {
			if (this.saveFollowUpTask()) {
				invalid_follow_up_tasks = false;
			} else {
				invalid_follow_up_tasks = true;
			}
		} else {
			invalid_follow_up_tasks = false;
		}

		if (this.validateFields(fields, this.activity_data, this.activity_data_errors) && !invalid_follow_up_tasks) {
			let payload: any = JSON.parse(JSON.stringify(this.activity_data));

			if (this.activity_data.scheduled_date != "" && this.activity_data.scheduled_date != null) {
				payload.scheduled_date = moment(this.activity_data.scheduled_date).format();
			}
			
			if (this.activity_data.actual_date != "" && this.activity_data.actual_date != null) {
				payload.actual_date = moment(this.activity_data.actual_date).format();
			}

			if (this.user_role == 'Wholesaler') {
				payload.advisor = this.activity_data.advisor;
				payload.wholesaler = this.activity_data.wholesaler;
			} else if (this.user_role == 'Leadership') {
				payload.recruiter = this.user_details.id;
				payload.advisor = this.activity_data.advisor;
			} else if (this.user_role != 'Advisor Manager') {
				payload.advisor = this.user_details.id;
				if (this.activity_data.user_type == "Client") {
					payload.client = this.activity_data.client;
				} else if (this.activity_data.user_type == "Prospect") {
					payload.prospect = this.activity_data.prospect_id;
				}
			} else {
				payload.advisor = this.activity_data.advisor;
				payload.advisor_manager = this.user_details.id;
			}

			let route: any = "";

			if (this.activity_data.source == 'csa') {
				route = "/clientsalesactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'lpa') {
				route = "/leadprospectactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'ama') {
				route = "/advisormanageractivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'Executive') {
				route = "/internalactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'Leadership') {
				route = "/recruiteractivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'Marketing Team') {
				route = "/internalactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'Branch') {
				route = "/internalactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'Product') {
				route = "/internalactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'Advisor Manager') {
				route = "/internalactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'Advisor') {
				route = "/internalactivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'wa') {
				route = "/wholesaleractivity/" + payload.id + "/";
			} else if (this.activity_data.source == 'ra') {
				route = "/recruiteractivity/" + payload.id + "/";
			}

			this.activity_save_loader = true;

			this.commonService.patch(route, payload).subscribe(
				(res: any) => {

					this.activity_data = res;

					if (this.activity_data.scheduled_date != "" && this.activity_data.scheduled_date != null) {
						// this.activity_data.scheduled_date = this.datePipe.transform(this.activity_data.scheduled_date, "MM/dd/yyyy");
						this.activity_data.scheduled_date = new Date(this.activity_data.scheduled_date);
					} else {
						this.activity_data.scheduled_date = "";
					}

					if (this.activity_data.actual_date != "" && this.activity_data.actual_date != null) {
						// this.activity_data.actual_date = this.datePipe.transform(this.activity_data.actual_date, "MM/dd/yyyy");
						this.activity_data.actual_date = new Date(this.activity_data.actual_date);
					} else {
						this.activity_data.actual_date = "";
					}

					this.commonService.showToast('success', "Activity Data Saved Succssfully.");

					this.activity_save_loader = false;

				},
				(err) => {
					this.commonService.showToast('error', err.error);
					this.activity_save_loader = false;
				},
			);

		}
	}

	follow_up_task_data: any = {
		name: "",
		channel: "",
		channel_name: "",
		scheduled_date: "",
		status: "",
		status_name: "",
		afa_id: "",
		description: "",
	};

	follow_up_task_data_errors: any = {
		name: false,
		channel: false,
		scheduled_date: false,
		status: false,
		afa_id: false,
		description: false,
	};

	follow_up_task_index: any  = null;
	follow_up_task_type: any  = "";

	followUpTaskOperations(data, index, type) {
		this.follow_up_task_data = JSON.parse(JSON.stringify(data));
		this.follow_up_task_index = index;
		this.follow_up_task_type = type;

		if (this.follow_up_task_type == "Edit") {
			this.follow_up_task_data.scheduled_date = new Date(this.follow_up_task_data.scheduled_date);
		}

	}

	saveFollowUpTask()  {
		if (this.follow_up_task_data.name != "" && this.follow_up_task_data.name != null) {
			this.follow_up_task_data_errors.name = false;
		} else {
			this.follow_up_task_data_errors.name = true;
		}

		// if (this.follow_up_task_data.description != "" && this.follow_up_task_data.description != null) {
		// 	this.follow_up_task_data_errors.description = false;
		// } else {
		// 	this.follow_up_task_data_errors.description = true;
		// }

		if (this.follow_up_task_data.channel != "" && this.follow_up_task_data.channel != null) {
			this.follow_up_task_data_errors.channel = false;
		} else {
			this.follow_up_task_data_errors.channel = true;
		}

		if (this.follow_up_task_data.scheduled_date != "" && this.follow_up_task_data.scheduled_date != null) {
			this.follow_up_task_data_errors.scheduled_date = false;
		} else {
			this.follow_up_task_data_errors.scheduled_date = true;
		}

		// if (this.follow_up_task_data.status != "" && this.follow_up_task_data.status != null) {
		// 	this.follow_up_task_data_errors.status = false;
		// } else {
		// 	this.follow_up_task_data_errors.status = true;
		// }

		// if (this.user_role != 'Advisor Manager') {
		// 	if (this.follow_up_task_data.afa_id != "" && this.follow_up_task_data.afa_id != null) {
		// 		this.follow_up_task_data_errors.afa_id = false;
		// 	} else {
		// 		this.follow_up_task_data_errors.afa_id = true;
		// 	}
		// } else {
		// 	this.follow_up_task_data_errors.afa_id = false;
		// }



		if (
			this.follow_up_task_data_errors.name == false &&
			// this.follow_up_task_data_errors.description == false &&
			this.follow_up_task_data_errors.channel == false &&
			this.follow_up_task_data_errors.scheduled_date == false
			// &&
			// this.follow_up_task_data_errors.status == false
			// this.follow_up_task_data_errors.afa_id == false
		) {
			if (this.follow_up_task_index == null) {
				// this.follow_up_tasks.push(this.follow_up_task_data);
				this.activity_data.followup_activities.push(this.follow_up_task_data);
			} else {
				// this.follow_up_tasks.splice(this.follow_up_task_index, 1, this.follow_up_task_data);
				this.activity_data.followup_activities.splice(this.follow_up_task_index, 1, this.follow_up_task_data);
			}
			setTimeout(() => {
				this.resetFollowUpTask();
			}, 200);
			return true;
		} else {
			return false;
		}

	}

	onChannelSelected(channel_id) {
		const channel = this.communication_type_list.find(c => c.id == channel_id);
		this.follow_up_task_data.channel_name = channel ? channel.name : '';
	}

	resetFollowUpTask() {
		this.follow_up_task_data = {
			name: "",
			channel: "",
			channel_name: "",
			scheduled_date: "",
			status: "",
			status_name: "",
			afa_id: "",
			description: "",
		};
		this.follow_up_task_data_errors = {
			name: false,
			channel: false,
			scheduled_date: false,
			status: false,
			afa_id: false,
			description: false,
		};
		this.follow_up_task_index = null;
		this.follow_up_task_type = "";
	}

	deleteFollowUpTask(index) {
		// this.follow_up_tasks.splice(index, 1);
		this.activity_data.followup_activities.splice(index, 1);
	}

	show_send_proosal: boolean = false;
	proposal_data_type: any = "";
	openSendProposalModal(data, type) {
		this.proposal_data_type = type;
		if (this.proposal_data_type == "Create") {
			this.proposal_data.objective_code = this.activity_data.objective_code;
		} else if (this.proposal_data_type == "Edit") {
			this.proposal_data = JSON.parse(JSON.stringify(data));
			this.proposal_data.scheduled_date = this.datePipe.transform(this.proposal_data.scheduled_date, "MM/dd/yyyy");
		}
		this.show_send_proosal = true;
	}

	closeSendProposalModal() {
		this.show_send_proosal = false;
		this.proposal_data = {
			objective_code: "",
			product: "",
			scheduled_date: new Date(),
			description: "",
			documents: [],
			subject: "",
			email_body: ""
		};
		this.proposal_data_errors = {
			objective_code: false,
			product: false,
			scheduled_date: false,
			description: false,
			documents: false,
			subject: false,
			email_body: false
		};
		this.proposal_data_type = "";
	}

	@ViewChild('proposalFile') proposalFile: any;
	uploadProposalFile(event)  {
		for (let index = 0; index < event.target.files.length; index++) {
			this.proposal_data.documents.push({
				document_file_name: event.target.files[index].name,
				document: event.target.files[index]
			});
		}
		// this.proposal_data.files.push({
		// 	name: event.target.files[0].name,
		// 	file: event.target.files[0]
		// });
		this.proposalFile.nativeElement.value = '';
	}

	deleteProposalFile(index)  {
		// this.proposal_data.files.splice(index, 1);
		this.proposal_data.documents.splice(index, 1);
	}

	editorConfig: any = {
		editable: true,
		  spellcheck: true,
		  height: 'auto',
		  minHeight: '0',
		  maxHeight: 'auto',
		  width: 'auto',
		  minWidth: '0',
		  translate: 'yes',
		  enableToolbar: true,
		  showToolbar: true,
		  placeholder: 'Enter text here...',
		  defaultParagraphSeparator: '',
		  defaultFontName: '',
		  defaultFontSize: '',
		  fonts: [
			{class: 'arial', name: 'Arial'},
			{class: 'times-new-roman', name: 'Times New Roman'},
			{class: 'calibri', name: 'Calibri'},
			{class: 'comic-sans-ms', name: 'Comic Sans MS'}
		  ],
		  customClasses: [
		  {
			name: 'quote',
			class: 'quote',
		  },
		  {
			name: 'redText',
			class: 'redText'
		  },
		  {
			name: 'titleText',
			class: 'titleText',
			tag: 'h1',
		  },
		],
		sanitize: true,
		toolbarPosition: 'top',
		toolbarHiddenButtons: [
		  // ['bold', 'italic'],
		  // ['fontSize']
		  ['insertImage', 'insertVideo',]
		]
	};
	proposal_data: any = {
		objective_code: "",
		product: "",
		scheduled_date: new Date(),
		description: "",
		documents: [],
		subject: "",
		email_body: ""
	};
	proposal_data_errors: any = {
		objective_code: false,
		product: false,
		scheduled_date: false,
		description: false,
		documents: false,
		subject: false,
		email_body: false
	};
	current_date: any = new Date();

	send_proposal_loader: boolean = false;
	sendProposal() {

		if (this.proposal_data.objective_code != "" && this.proposal_data.objective_code != null) {
			this.proposal_data_errors.objective_code = false;
		} else {
			this.proposal_data_errors.objective_code = true;
		}

		if (this.proposal_data.product != "" && this.proposal_data.product != null) {
			this.proposal_data_errors.product = false;
		} else {
			this.proposal_data_errors.product = true;
		}

		if (this.proposal_data.scheduled_date != "" && this.proposal_data.scheduled_date != null) {
			this.proposal_data_errors.scheduled_date = false;
		} else {
			this.proposal_data_errors.scheduled_date = true;
		}

		// if (this.proposal_data.description != "" && this.proposal_data.description != null) {
		// 	this.proposal_data_errors.description = false;
		// } else {
		// 	this.proposal_data_errors.description = true;
		// }

		if (this.proposal_data.subject != "" && this.proposal_data.subject != null) {
			this.proposal_data_errors.subject = false;
		} else {
			this.proposal_data_errors.subject = true;
		}

		if (this.proposal_data.email_body != "" && this.proposal_data.email_body != null) {
			this.proposal_data_errors.email_body = false;
		} else {
			this.proposal_data_errors.email_body = true;
		}

		if (this.proposal_data.documents.length > 0) {
			this.proposal_data_errors.documents = false;
		} else {
			this.proposal_data_errors.documents = true;
		}

		if (
			this.proposal_data_errors.objective_code == false &&
			this.proposal_data_errors.product == false &&
			this.proposal_data_errors.scheduled_date == false &&
			// this.proposal_data_errors.description == false &&
			this.proposal_data_errors.subject == false &&
			this.proposal_data_errors.email_body == false &&
			this.proposal_data_errors.documents == false
		) {
			this.send_proposal_loader = true;

			let payload: any = {
				type: "",
				description: this.proposal_data.description,
				objective_code: this.proposal_data.objective_code,
				product: this.proposal_data.product,
				client_list: [],
				scheduled_date: moment(this.proposal_data.scheduled_date).format(),
				subject: this.proposal_data.subject,
				email_body: this.proposal_data.email_body,
			};

			// if (this.type == "Opportunities") {
			// 	payload.type = "opportunity";
			// } else if (this.type == "Retention Opportunities") {
			// 	payload.type = "retention";
			// // } else if (this.type == "Institutional Customers to Investment Clients") {
			// } else if (this.type == "US Prospects") {
			// 	payload.type = "new";
			// // } else if (this.type == "Institutional Customers to Deposit Clients") {
			// } else if (this.type == "Bank Customers to Deposit Clients") {
			// 	// payload.type = "members";
			// 	payload.type = "new";
			// } else if (this.type == "Non Customers") {
			// 	// payload.type = "non_members";
			// 	payload.type = "new";
			// }

			// for (let index = 0; index < this.selected_table_data.length; index++) {
			// 	payload.client_list.push(this.selected_table_data[index].id);
			// }

			// payload.client_id = this.send_proposal_client.id;

			// payload.client_id = this.activity_data.client_id;
			payload.client_id = this.activity_data.client;
			payload.type = this.activity_data.proposal_type;
			payload.task_id = this.activity_data.id;

			

			let route: any = "";

			if (this.proposal_data_type == "Create") {
				let formData = new FormData();
				// formData.append('client_list', payload.client_list);
				formData.append('client_id', payload.client_id);
				formData.append('type', payload.type);
				formData.append('description', payload.description);
				formData.append('objective_code', payload.objective_code);
				formData.append('product', payload.product);
				formData.append('scheduled_date', payload.scheduled_date);
				formData.append('not_required', payload.not_required);
				formData.append('files_count', this.proposal_data.documents.length);
				formData.append('subject', payload.subject);
				formData.append('email_body', payload.email_body);

				formData.append('task_id', payload.task_id);

				for (let index = 0; index < this.proposal_data.documents.length; index++) {
					const key = "proposal_file_" + (index +  1);
					formData.append(key, this.proposal_data.documents[index].document);
				}
				route = "/sendproposal_new/";

				this.commonService.postData(route, formData).subscribe(
					(res: any) => {
						this.closeSendProposalModal();
						this.getActivityData();
						this.commonService.showToast('success', "The document will be sent via email on the scheduled date.");
						this.send_proposal_loader = false;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.send_proposal_loader = false;
					},
				);
			} else if (this.proposal_data_type == "Edit") {
				let formData = new FormData();
				// formData.append('client_list', payload.client_list);
				formData.append('client_id', payload.client_id);
				formData.append('type', payload.type);
				formData.append('description', payload.description);
				formData.append('objective_code', payload.objective_code);
				formData.append('product', payload.product);
				formData.append('scheduled_date', payload.scheduled_date);
				formData.append('not_required', payload.not_required);
				// formData.append('files_count', this.proposal_data.documents.length);
				formData.append('subject', payload.subject);
				formData.append('email_body', payload.email_body);

				formData.append('task_id', payload.task_id);

				let files_count: any = 0;
				let existing_files_ids: any = [];

				for (let index = 0; index < this.proposal_data.documents.length; index++) {
					let key = "";
					if (!this.proposal_data.documents[index].id) {
						// key = "proposal_file_" + (index +  1);
						files_count = files_count + 1;
						key = "proposal_file_" + (files_count);
						formData.append(key, this.proposal_data.documents[index].document);
					} else {
						existing_files_ids.push(this.proposal_data.documents[index].id);;
					}
				}
				formData.append('files_count', files_count);
				formData.append('existing_files_ids', existing_files_ids);
				formData.append("id", this.proposal_data.id);
				this.commonService.postData("/updateproposal/", formData).subscribe(
					(res: any) => {
						this.closeSendProposalModal();
						this.getActivityData();
						this.commonService.showToast('success', "The document will be sent via email on the scheduled date.");
						this.send_proposal_loader = false;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.send_proposal_loader = false;
					},
				);
			}

		}
	}

	objectives_list: any = [];
	getObjectives() {
		let route = '/getobjectives/';
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.objectives_list = res["objectives"];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	products_list: any = [];
	getProducts() {
		let route = '/product?no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.products_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	client_product_status_list: any = [];
	getClientProductStatus() {
		this.commonService.getData('/clientProductStatus/?no_page=true').subscribe(
			(res: any) => {
				this.client_product_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	attrition_reasons_list: any = [];
	getAttritionReasons() {
		// let route = '/attritionreasons?financial_institution=' + this.user_details.financial_institution + '&no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		let route = '/attritionreasons?no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.attrition_reasons_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	getProductType(id) {
		const index = this.products_list.findIndex((x: any) => x.id == id);
		if (index > -1) {
			// this.product_data.product_type = this.products_list[index].product_type;
			this.product_data.product_type = this.products_list[index].product_type;
			if (this.products_list[index].product_type == 'Life Time') {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	conversion_status_list: any = [];
	getConversionStatusList() {
		this.commonService.getData('/conversionStatus/?no_page=true').subscribe(
			(res: any) => {
				this.conversion_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@ViewChild('viewProposalModal') viewProposalModal: TemplateRef<any>;
	private viewProposalModalRef: MatDialogRef<TemplateRef<any>>;
	view_proposal_data: any;
	viewProposal(proposal) {
		this.view_proposal_data =JSON.parse(JSON.stringify(proposal));
		this.viewProposalModalRef = this.dialog.open(this.viewProposalModal, { disableClose: true });
		this.viewProposalModalRef.afterClosed().subscribe((result) => {
			this.closeViewProposalModal();
		});
	}

	closeViewProposalModal() {
		this.viewProposalModalRef.close();
	}

	@ViewChild('scheduleMeetingModal') scheduleMeetingModal: TemplateRef<any>;
	private scheduleMeetingModalRef: MatDialogRef<TemplateRef<any>>;

	schedule_meeting_type: any = "";
	schedule_meeting_index: any = null;
	openScheduleMeetingModal(type, index) {
		this.generateTimeSlots();
		this.generateDurationSlots();
		this.generateTimeZones();


		this.schedule_meeting_type = JSON.parse(JSON.stringify(type));
		this.schedule_meeting_index = JSON.parse(JSON.stringify(index));

		this.scheduleMeetingModalRef = this.dialog.open(
			this.scheduleMeetingModal, { disableClose: true }
		);
		this.scheduleMeetingModalRef.afterClosed().subscribe((result) => {
			this.closeScheduleMeetingModal();
		});
	}

	closeScheduleMeetingModal() {
		this.scheduleMeetingModalRef.close();
		this.meeting_data = {
			topic: "",
			description: "",
			when: new Date(),
			time: "",
			duration: "",
			timezone: "",
			attendees: [],
			attachments: [],
      platform: "",
		};
		this.meeting_data_errors = {
			topic: false,
			description: false,
			when: false,
			time: false,
			duration: false,
			timezone: false,
			attendees: false,
			attachments: false,
      platform: false,
		};
		this.schedule_meeting_type = "";
		this.schedule_meeting_index = null;
	}

	meeting_data: any = {
		topic: "",
		description: "",
		when: new Date(),
		time: "",
		duration: "",
		timezone: "",
		attendees: [],
		attachments: [],
    platform: "",
	};
	meeting_data_errors: any = {
		topic: false,
		description: false,
		when: false,
		time: false,
		duration: false,
		timezone: false,
		attendees: false,
		attachments: false,
    platform: false,
	};

	@ViewChild('meetingAtachmentFile') meetingAtachmentFile: any;
	uploadAtatchmentFile(event) {
		for (let index = 0; index < event.target.files.length; index++) {
			this.meeting_data.attachments.push({
				name: event.target.files[index].name,
				file: event.target.files[index]
			});
		}
		this.meetingAtachmentFile.nativeElement.value = '';
	}

	deleteAttachmentFile(index) {
		this.meeting_data.attachments.splice(index, 1);
	}

	separatorKeysCodes: number[] = [ENTER, COMMA];
	attendees_error: boolean = false;

	addAtteendeeEmail(event: any): void {
		const input = event.input;
		const value = event.value.trim();

		// Email validation regex
		const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

		if (value && emailPattern.test(value)) {
			this.meeting_data.attendees.push(value);
			this.attendees_error = false;
		} else if (value) {
			this.attendees_error = true;
		}

		// Reset the input value
		if (input) {
			input.value = '';
		}
	}

	removeAtteendeeEmail(email: string): void {
		const index = this.meeting_data.attendees.indexOf(email);

		if (index >= 0) {
			this.meeting_data.attendees.splice(index, 1);
		}
	}

	scheduleMeeting() {
		if (this.meeting_data.topic != "" && this.meeting_data.topic != null) {
			this.meeting_data_errors.topic = false;
		} else {
			this.meeting_data_errors.topic = true;
		}

		if (this.meeting_data.description != "" && this.meeting_data.description != null) {
			this.meeting_data_errors.description = false;
		} else {
			this.meeting_data_errors.description = true;
		}

		if (this.meeting_data.when != "" && this.meeting_data.when != null) {
			this.meeting_data_errors.when = false;
		} else {
			this.meeting_data_errors.when = true;
		}

		if (this.meeting_data.time != "" && this.meeting_data.time != null) {
			this.meeting_data_errors.time = false;
		} else {
			this.meeting_data_errors.time = true;
		}

		if (this.meeting_data.duration != "" && this.meeting_data.duration != null) {
			this.meeting_data_errors.duration = false;
		} else {
			this.meeting_data_errors.duration = true;
		}

		if (this.meeting_data.timezone != "" && this.meeting_data.timezone != null) {
			this.meeting_data_errors.timezone = false;
		} else {
			this.meeting_data_errors.timezone = true;
		}

    if (this.meeting_data.platform != "" && this.meeting_data.platform != null) {
			this.meeting_data_errors.platform = false;
		} else {
			this.meeting_data_errors.platform = true;
		}

		if (
			this.meeting_data_errors.topic == false &&
			this.meeting_data_errors.description == false &&
			this.meeting_data_errors.when == false &&
			this.meeting_data_errors.time == false &&
			this.meeting_data_errors.duration == false &&
			this.meeting_data_errors.timezone == false &&
			this.meeting_data_errors.platform == false
		) {
			if (this.schedule_meeting_type == 'activity') {
				let route: any = "/schedulezoommeeting/";

				let payload: any = {
					topic: this.meeting_data.topic,
					description: this.meeting_data.description,
					duration: this.meeting_data.duration,
					start_date: moment(this.meeting_data.when).format("YYYY-MM-DD"),
					start_time_full: this.meeting_data.time,
					timezone: this.meeting_data.timezone,
					platform: this.meeting_data.platform,
					activity_id: this.activity_data.id,
					source: this.activity_data.source,
					attendees: this.meeting_data.attendees,
				};

				// const formData = new FormData();
				// formData.append('topic', this.meeting_data.topic);
				// formData.append('description', this.meeting_data.description);
				// formData.append('duration', this.meeting_data.duration);
				// formData.append('start_date', moment(this.meeting_data.when).format("YYYY-MM-DD"));
				// formData.append('start_time_full', this.meeting_data.time);
				// formData.append('timezone', this.meeting_data.timezone);
				// formData.append('activity_id', this.activity_data.id);
				// formData.append('source', this.activity_data.source);

				// formData.append('files_count', this.meeting_data.attachments.length);
				// formData.append('attendees', this.meeting_data.attendees);

				// if (this.meeting_data.attachments.length > 0) {
				// 	for (let index = 0; index < this.meeting_data.attachments.length; index++) {
				// 		const key = "attachment_file_" + (index + 1);
				// 		formData.append(key, this.meeting_data.attachments[index].file);
				// 	}
				// }

				// this.commonService.postData(route, formData).subscribe(
				this.commonService.postData(route, payload).subscribe(
					(res: any) => {
						this.closeScheduleMeetingModal();
						this.getActivityData();
						this.commonService.showToast('success', 'Meeting has been scheduled successfully. A confirmation email has been sent to the client, and meeting details have been recorded in the comments section.');
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			} else if (this.schedule_meeting_type == 'action-item') {
				// const formData = new FormData();
				// formData.append('topic', this.meeting_data.topic);
				// formData.append('description', this.meeting_data.description);
				// formData.append('duration', this.meeting_data.duration);
				// formData.append('start_date', moment(this.meeting_data.when).format("YYYY-MM-DD"));
				// formData.append('start_time_full', this.meeting_data.time);
				// formData.append('timezone', this.meeting_data.timezone);
				// // formData.append('activity_id', this.activity_data.id);
				// // formData.append('source', this.activity_data.source);

				// formData.append('files_count', this.meeting_data.attachments.length);
				// formData.append('attendees', this.meeting_data.attendees);

				// if (this.meeting_data.attachments.length > 0) {
				// 	for (let index = 0; index < this.meeting_data.attachments.length; index++) {
				// 		const key = "attachment_file_" + (index + 1);
				// 		formData.append(key, this.meeting_data.attachments[index].file);
				// 	}
				// }

				let payload: any = {
					topic: this.meeting_data.topic,
					description: this.meeting_data.description,
					duration: this.meeting_data.duration,
					start_date: moment(this.meeting_data.when).format("YYYY-MM-DD"),
					start_time_full: this.meeting_data.time,
					timezone: this.meeting_data.timezone,
					platform: this.meeting_data.platform,
					activity_id: this.activity_data.id,
					source: this.activity_data.source,
					attendees: this.meeting_data.attendees,
				};

				// this.activity_data.followup_activities[this.schedule_meeting_index].meeting_details = formData;
				this.activity_data.followup_activities[this.schedule_meeting_index].meeting_details = payload;

				this.closeScheduleMeetingModal();
			} else if (this.schedule_meeting_type == 'individual-activity') {
				let payload: any = {
					topic: this.meeting_data.topic,
					description: this.meeting_data.description,
					duration: this.meeting_data.duration,
					start_date: moment(this.meeting_data.when).format("YYYY-MM-DD"),
					start_time_full: this.meeting_data.time,
					timezone: this.meeting_data.timezone,
					platform: this.meeting_data.platform,
					activity_id: this.activity_data.id,
					source: this.activity_data.source,
					attendees: this.meeting_data.attendees,
				};

				this.activity_data.meeting_details = payload;

				this.closeScheduleMeetingModal();
			}
		}

	}

	time_slots: any = [];
	generateTimeSlots() {
		const now = new Date();
		const start = new Date(this.meeting_data.when);
		start.setHours(0, 0, 0, 0);  // Set to midnight
		const end = new Date(start);
		end.setDate(end.getDate() + 1);  // End at midnight of the next day

		this.time_slots = [];

		while (start < end) {
			if (start > now) {  // Only add future time slots
				const hours = start.getHours();
				const minutes = start.getMinutes();
				const ampm = hours >= 12 ? 'PM' : 'AM';
				const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
				const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
				this.time_slots.push(`${formattedHours}:${formattedMinutes} ${ampm}`);
			}
			start.setMinutes(start.getMinutes() + 15);
		}
	}

	duration_slots: any = [];
	generateDurationSlots() {
		const totalMinutesInDay = 24 * 60;
		const interval = 15; // 15-minute intervals

		this.duration_slots = [];

		for (let minutes = interval; minutes <= totalMinutesInDay; minutes += interval) {
			const hours = Math.floor(minutes / 60);
			const remainingMinutes = minutes % 60;
			let duration = '';

			if (hours > 0) {
				duration += `${hours} hour${hours > 1 ? 's' : ''}`;
			}

			if (remainingMinutes > 0) {
				if (hours > 0) {
					duration += ' ';
				}
				duration += `${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`;
			}

			this.duration_slots.push({ name: duration, value: minutes });

		}
	}

	timezone_list: any = [];
	generateTimeZones() {
		const timeZonesObject = {
			"Pacific/Midway": "(GMT-11:00) Midway Island, Samoa",
			"Pacific/Pago_Pago": "(GMT-11:00) Pago Pago",
			"Pacific/Honolulu": "(GMT-10:00) Hawaii",
			"America/Anchorage": "(GMT-8:00) Alaska",
			"America/Juneau": "(GMT-8:00) Juneau",
			"America/Vancouver": "(GMT-7:00) Vancouver",
			"America/Los_Angeles": "(GMT-7:00) Pacific Time (US and Canada)",
			"America/Tijuana": "(GMT-7:00) Tijuana",
			"America/Phoenix": "(GMT-7:00) Arizona",
			"America/Edmonton": "(GMT-6:00) Edmonton",
			"America/Denver": "(GMT-6:00) Mountain Time (US and Canada)",
			"America/Mazatlan": "(GMT-6:00) Mazatlan",
			"America/Regina": "(GMT-6:00) Saskatchewan",
			"America/Guatemala": "(GMT-6:00) Guatemala",
			"America/El_Salvador": "(GMT-6:00) El Salvador",
			"America/Managua": "(GMT-6:00) Managua",
			"America/Costa_Rica": "(GMT-6:00) Costa Rica",
			"America/Tegucigalpa": "(GMT-6:00) Tegucigalpa",
			"America/Chihuahua": "(GMT-6:00) Chihuahua",
			"America/Winnipeg": "(GMT-5:00) Winnipeg",
			"America/Chicago": "(GMT-5:00) Central Time (US and Canada)",
			"America/Mexico_City": "(GMT-5:00) Mexico City",
			"America/Panama": "(GMT-5:00) Panama",
			"America/Bogota": "(GMT-5:00) Bogota",
			"America/Lima": "(GMT-5:00) Lima",
			"America/Monterrey": "(GMT-5:00) Monterrey",
			"America/Montreal": "(GMT-4:00) Montreal",
			"America/New_York": "(GMT-4:00) Eastern Time (US and Canada)",
			"America/Indianapolis": "(GMT-4:00) Indiana (East)",
			"America/Puerto_Rico": "(GMT-4:00) Puerto Rico",
			"America/Caracas": "(GMT-4:00) Caracas",
			"America/Santiago": "(GMT-4:00) Santiago",
			"America/La_Paz": "(GMT-4:00) La Paz",
			"America/Guyana": "(GMT-4:00) Guyana",
			"America/Halifax": "(GMT-3:00) Halifax",
			"America/Montevideo": "(GMT-3:00) Montevideo",
			"America/Araguaina": "(GMT-3:00) Recife",
			"America/Argentina/Buenos_Aires": "(GMT-3:00) Buenos Aires, Georgetown",
			"America/Sao_Paulo": "(GMT-3:00) Sao Paulo",
			"Canada/Atlantic": "(GMT-3:00) Atlantic Time (Canada)",
			"America/St_Johns": "(GMT-2:30) Newfoundland and Labrador",
			"America/Godthab": "(GMT-2:00) Greenland",
			"Atlantic/Cape_Verde": "(GMT-1:00) Cape Verde Islands",
			"Atlantic/Azores": "(GMT+0:00) Azores",
			"UTC": "(GMT+0:00) Universal Time UTC",
			"Etc/Greenwich": "(GMT+0:00) Greenwich Mean Time",
			"Atlantic/Reykjavik": "(GMT+0:00) Reykjavik",
			"Africa/Casablanca": "(GMT+0:00) Casablanca",
			"Africa/Nouakchott": "(GMT+0:00) Nouakchott",
			"Europe/Dublin": "(GMT+1:00) Dublin",
			"Europe/London": "(GMT+1:00) London",
			"Europe/Lisbon": "(GMT+1:00) Lisbon",
			"Africa/Bangui": "(GMT+1:00) West Central Africa",
			"Africa/Algiers": "(GMT+1:00) Algiers",
			"Africa/Tunis": "(GMT+1:00) Tunis",
			"Europe/Belgrade": "(GMT+2:00) Belgrade, Bratislava, Ljubljana",
			"CET": "(GMT+2:00) Sarajevo, Skopje, Zagreb",
			"Europe/Oslo": "(GMT+2:00) Oslo",
			"Europe/Copenhagen": "(GMT+2:00) Copenhagen",
			"Europe/Brussels": "(GMT+2:00) Brussels",
			"Europe/Berlin": "(GMT+2:00) Amsterdam, Berlin, Rome, Stockholm, Vienna",
			"Europe/Amsterdam": "(GMT+2:00) Amsterdam",
			"Europe/Rome": "(GMT+2:00) Rome",
			"Europe/Stockholm": "(GMT+2:00) Stockholm",
			"Europe/Vienna": "(GMT+2:00) Vienna",
			"Europe/Luxembourg": "(GMT+2:00) Luxembourg",
			"Europe/Paris": "(GMT+2:00) Paris",
			"Europe/Zurich": "(GMT+2:00) Zurich",
			"Europe/Madrid": "(GMT+2:00) Madrid",
			"Africa/Harare": "(GMT+2:00) Harare, Pretoria",
			"Europe/Warsaw": "(GMT+2:00) Warsaw",
			"Europe/Prague": "(GMT+2:00) Prague Bratislava",
			"Europe/Budapest": "(GMT+2:00) Budapest",
			"Africa/Tripoli": "(GMT+2:00) Tripoli",
			"Africa/Cairo": "(GMT+2:00) Cairo",
			"Africa/Johannesburg": "(GMT+2:00) Johannesburg",
			"Africa/Khartoum": "(GMT+2:00) Khartoum",
			"Europe/Helsinki": "(GMT+3:00) Helsinki",
			"Africa/Nairobi": "(GMT+3:00) Nairobi",
			"Europe/Sofia": "(GMT+3:00) Sofia",
			"Europe/Istanbul": "(GMT+3:00) Istanbul",
			"Europe/Athens": "(GMT+3:00) Athens",
			"Europe/Bucharest": "(GMT+3:00) Bucharest",
			"Asia/Nicosia": "(GMT+3:00) Nicosia",
			"Asia/Beirut": "(GMT+3:00) Beirut",
			"Asia/Damascus": "(GMT+3:00) Damascus",
			"Asia/Jerusalem": "(GMT+3:00) Jerusalem",
			"Asia/Amman": "(GMT+3:00) Amman",
			"Europe/Moscow": "(GMT+3:00) Moscow",
			"Asia/Baghdad": "(GMT+3:00) Baghdad",
			"Asia/Kuwait": "(GMT+3:00) Kuwait",
			"Asia/Riyadh": "(GMT+3:00) Riyadh",
			"Asia/Bahrain": "(GMT+3:00) Bahrain",
			"Asia/Qatar": "(GMT+3:00) Qatar",
			"Asia/Aden": "(GMT+3:00) Aden",
			"Africa/Djibouti": "(GMT+3:00) Djibouti",
			"Africa/Mogadishu": "(GMT+3:00) Mogadishu",
			"Europe/Kiev": "(GMT+3:00) Kiev",
			"Europe/Minsk": "(GMT+3:00) Minsk",
			"Asia/Dubai": "(GMT+4:00) Dubai",
			"Asia/Muscat": "(GMT+4:00) Muscat",
			"Asia/Baku": "(GMT+4:00) Baku, Tbilisi, Yerevan",
			"Asia/Tehran": "(GMT+4:30) Tehran",
			"Asia/Kabul": "(GMT+4:30) Kabul",
			"Asia/Yekaterinburg": "(GMT+5:00) Yekaterinburg",
			"Asia/Tashkent": "(GMT+5:00) Islamabad, Karachi, Tashkent",
			"Asia/Calcutta": "(GMT+5:30) India",
			"Asia/Kolkata": "(GMT+5:30) Mumbai, Kolkata, New Delhi",
			"Asia/Colombo": "(GMT+5:30) Asia/Colombo",
			"Asia/Kathmandu": "(GMT+5:45) Kathmandu",
			"Asia/Almaty": "(GMT+6:00) Almaty",
			"Asia/Dacca": "(GMT+6:00) Dacca",
			"Asia/Dhaka": "(GMT+6:00) Astana, Dhaka",
			"Asia/Rangoon": "(GMT+6:30) Rangoon",
			"Asia/Novosibirsk": "(GMT+7:00) Novosibirsk",
			"Asia/Krasnoyarsk": "(GMT+7:00) Krasnoyarsk",
			"Asia/Bangkok": "(GMT+7:00) Bangkok",
			"Asia/Saigon": "(GMT+7:00) Vietnam",
			"Asia/Jakarta": "(GMT+7:00) Jakarta",
			"Asia/Irkutsk": "(GMT+8:00) Irkutsk, Ulaanbaatar",
			"Asia/Shanghai": "(GMT+8:00) Beijing, Shanghai",
			"Asia/Hong_Kong": "(GMT+8:00) Hong Kong SAR",
			"Asia/Taipei": "(GMT+8:00) Taipei",
			"Asia/Kuala_Lumpur": "(GMT+8:00) Kuala Lumpur",
			"Asia/Singapore": "(GMT+8:00) Singapore",
			"Australia/Perth": "(GMT+8:00) Perth",
			"Asia/Yakutsk": "(GMT+9:00) Yakutsk",
			"Asia/Seoul": "(GMT+9:00) Seoul",
			"Asia/Tokyo": "(GMT+9:00) Osaka, Sapporo, Tokyo",
			"Australia/Darwin": "(GMT+9:30) Darwin",
			"Australia/Adelaide": "(GMT+9:30) Adelaide",
			"Asia/Vladivostok": "(GMT+10:00) Vladivostok",
			"Pacific/Port_Moresby": "(GMT+10:00) Guam, Port Moresby",
			"Australia/Brisbane": "(GMT+10:00) Brisbane",
			"Australia/Sydney": "(GMT+10:00) Canberra, Melbourne, Sydney",
			"Australia/Hobart": "(GMT+10:00) Hobart",
			"Asia/Magadan": "(GMT+11:00) Magadan",
			"SST": "(GMT+11:00) Solomon Islands",
			"Pacific/Noumea": "(GMT+11:00) New Caledonia",
			"Asia/Kamchatka": "(GMT+12:00) Kamchatka",
			"Pacific/Fiji": "(GMT+12:00) Fiji Islands, Marshall Islands",
			"Pacific/Auckland": "(GMT+12:00) Auckland, Wellington",
			"Pacific/Apia": "(GMT+13:00) Independent State of Samoa"
		};

		this.timezone_list = [];

		this.timezone_list = Object.keys(timeZonesObject).map(key => {
			return { value: key, name: `${key} : ${timeZonesObject[key]}` };
		});

	}

	@ViewChild('closeDealModal') closeDealModal: TemplateRef<any>;
	private closeDealModalRef: MatDialogRef<TemplateRef<any>>;

	openCloseDealModal() {
		this.closeDealModalRef = this.dialog.open(this.closeDealModal, { disableClose: true });
		this.closeDealModalRef.afterClosed().subscribe((result) => {
			this.hideDealModal();
		});
	}

	hideDealModal() {
		this.closeDealModalRef.close();
		this.hideCloseDealView();
	}

	hideCloseDealView() {
		// this.show_close_deal_view = false;
		if (this.user_details.role.business_area[0] == '5') {
			this.resetCloseDealData();
		}
		if (this.user_details.role.business_area[0] == '6') {
			this.resetDepositCloseDealData();
		}
    if (this.user_details.role.business_area[0] == '7') {
			this.resetLendingCloseDealData();
		}
    if (this.user_details.role.business_area[0] == '8') {
			this.resetInsuranceCloseDealData();
		}
	}


	// Close Deal Code
	conversion_status_data: any = {
		conversion_status: '',
		conversion_comments: '',
	};
	conversion_status_data_errors: any = {
		conversion_status: false,
		conversion_comments: false,
	};


	addProduct() {
		if (this.validateConversionStatus()) {
			if (this.conversion_status_data.conversion_status == 1) {
				if (this.user_details.role.business_area[0] == '5') {
					if (this.validateProductInformation()) {
						this.saveConversionStatusData(this.activity_data);
						// this.saveProductInformation();
					}
				}
				if (this.user_details.role.business_area[0] == '6') {
					if (this.validateDepositProductInformation()) {
						this.saveConversionStatusData(this.activity_data);
						// this.saveProductInformation();
					}
				}

        if (this.user_details.role.business_area[0] == '7') {
					if (this.validateLendingProductInformation()) {
						this.saveConversionStatusData(this.activity_data);
						// this.saveProductInformation();
					}
				}

        if (this.user_details.role.business_area[0] == '8') {
					if (this.validateInsuranceProductInformation()) {
						this.saveConversionStatusData(this.activity_data);
						// this.saveProductInformation();
					}
				}
			} else {
				this.saveConversionStatusData(this.activity_data);
			}
		}
	}

	resetCloseDealData() {
		this.hideDealModal();
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.product_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
		};
		this.product_data_errors = {
			client_id: false,
			client_type: false,
			expected_aum: false,
			expected_closure_date: false,
			status: false,
			policy_number: false,
			aum: false,
			start_date: false,
			product: false,
			close_date: false,
			type: false,
			client_product_status: false,
		};
		this.product_operation_type = "Add";
		
		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};
	}

	validateConversionStatus() {
		if (
			this.conversion_status_data.conversion_status != '' &&
			this.conversion_status_data.conversion_status != null
		) {
			this.conversion_status_data_errors.conversion_status = false;
		} else {
			this.conversion_status_data_errors.conversion_status = true;
		}

		if (
			this.conversion_status_data.conversion_comments != '' &&
			this.conversion_status_data.conversion_comments != null
		) {
			this.conversion_status_data_errors.conversion_comments = false;
		} else {
			this.conversion_status_data_errors.conversion_comments = true;
		}

		if (
			this.conversion_status_data_errors.conversion_status == false &&
			this.conversion_status_data_errors.conversion_comments == false
		) {
			if (this.conversion_status_data.conversion_status == 1) {
				this.validateProductInformation();
				return true;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

	saveConversionStatusData(data) {
		let payload: any = {
			conversion_status_id: this.conversion_status_data.conversion_status,
			conversion_comments: this.conversion_status_data.conversion_comments,
			client_id: this.activity_data.client,
		};

		if (!data) {
			payload.id = "";
		} else {
			if (data.source == 'csa') {
				payload.csa_id = data.id;
				payload.user_type = "Client";
			} else if (data.source == 'lpa') {
				payload.lpa_id = data.id;
				payload.user_type = "Prospect";
			} else if (data.source == 'ama') {
				payload.ama_id = data.id;
			} else if (data.source == 'Executive') {
				payload.int_id = data.id;
			} else if (data.source == 'Leadership') {
				payload.int_id = data.id;
			} else if (data.source == 'Marketing Team') {
				payload.int_id = data.id;
			}
		}

		// if (this.stepper_stage) {
		// 	payload.stepper_type = this.stepper_stage.type;
		// }

		this.commonService.postData('/captureclientconversionstatus/', payload).subscribe(
			(res: any) => {
				if (this.conversion_status_data.conversion_status != 1) {
					this.resetCloseDealData();
					this.resetDepositCloseDealData();
					this.resetLendingCloseDealData();
					this.resetInsuranceCloseDealData();
					this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);

					if (this.closeDealModalRef) {
						this.hideDealModal();
						// this.close();
						this.getActivityData();
					}

				} else {
					this.saveProductInformation();
				}
				// this.commonService.showToast('success','Conversion Status Changed Successfully.',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
	};
	product_data_errors: any = {
		client_id: false,
		client_type: false,
		expected_aum: false,
		expected_closure_date: false,
		status: false,
		policy_number: false,
		aum: false,
		start_date: false,
		product: false,
		close_date: false,
		type: false,
		client_product_status: false,
		deposit_purpose: false,
	};

	depositProduct_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',

	};
	depositProduct_data_errors: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',
	};

	depositProduct_operation_type: any = "Add";
	validateDepositProductInformation() {
		// if (
		// 	this.depositProduct_data.policy_number != '' &&
		// 	this.depositProduct_data.policy_number != null
		// ) {
		// 	this.depositProduct_data_errors.policy_number = false;
		// } else {
		// 	this.depositProduct_data_errors.policy_number = true;
		// }

		if (
			this.depositProduct_data.aum != '' &&
			this.depositProduct_data.aum != null
		) {
			this.depositProduct_data_errors.aum = false;
		} else {
			this.depositProduct_data_errors.aum = true;
		}

		if (
			this.depositProduct_data.start_date != '' &&
			this.depositProduct_data.start_date != null
		) {
			this.depositProduct_data_errors.start_date = false;
		} else {
			this.depositProduct_data_errors.start_date = true;
		}

		if (
			this.depositProduct_data.product != '' &&
			this.depositProduct_data.product != null
		) {
			this.depositProduct_data_errors.product = false;
		} else {
			this.depositProduct_data_errors.product = true;
		}

		if (this.depositProduct_data.close_date != "" && this.depositProduct_data.close_date != null) {
			this.depositProduct_data_errors.close_date = false;
		} else {
			this.depositProduct_data_errors.close_date = true;
		}

		if (
			this.depositProduct_data.product_type == 'Life Time' ||
			(this.depositProduct_data.close_date != '' &&
				this.depositProduct_data.close_date != null)
		) {
			this.depositProduct_data_errors.close_date = false;
		} else {
			this.depositProduct_data_errors.close_date = true;
		}

		// if (
		// 	this.depositProduct_data.type != '' &&
		// 	this.depositProduct_data.type != null
		// ) {
		// 	this.depositProduct_data_errors.type = false;
		// } else {
		// 	this.depositProduct_data_errors.type = true;
		// }


		if (
			this.depositProduct_data.interest_rate != '' &&
			this.depositProduct_data.interest_rate != null
		) {
			this.depositProduct_data_errors.interest_rate = false;
		} else {
			this.depositProduct_data_errors.interest_rate = true;
		}

		if (
			this.depositProduct_data.monthly_fees != '' &&
			this.depositProduct_data.monthly_fees != null
		) {
			this.depositProduct_data_errors.monthly_fees = false;
		} else {
			this.depositProduct_data_errors.monthly_fees = true;
		}

		// if (
		// 	this.depositProduct_data.client_product_status != '' &&
		// 	this.depositProduct_data.client_product_status != null
		// ) {
		// 	this.depositProduct_data_errors.client_product_status = false;
		// } else {
		// 	this.depositProduct_data_errors.client_product_status = true;
		// }

		// if (this.user_role == "Relationship Manager") {
		// 	if (
		// 		this.depositProduct_data.deposit_purpose != '' &&
		// 		this.depositProduct_data.deposit_purpose != null
		// 	) {
		// 		this.depositProduct_data_errors.deposit_purpose = false;
		// 	} else {
		// 		this.depositProduct_data_errors.deposit_purpose = true;
		// 	}
		// }
		// else {
		// 	this.depositProduct_data.deposit_purpose = "";
		// 	this.depositProduct_data_errors.deposit_purpose = false;
		// }

		if (
			// this.depositProduct_data_errors.policy_number == false &&
			this.depositProduct_data_errors.aum == false &&
			this.depositProduct_data_errors.start_date == false &&
			this.depositProduct_data_errors.product == false &&
			this.depositProduct_data_errors.close_date == false &&
			// this.depositProduct_data_errors.type == false &&
			// this.depositProduct_data_errors.client_product_status == false &&
			this.depositProduct_data_errors.interest_rate == false &&
			this.depositProduct_data_errors.monthly_fees == false &&
			this.min_amount_error == false
			// this.depositProduct_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}


	resetDepositCloseDealData() {
		this.hideDealModal();
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.depositProduct_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		this.depositProduct_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};
		this.depositProduct_operation_type = "Add";
		
		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};
	}

  lending_product_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',

	};
	lending_product_data_errors: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',
	};

	lending_product_operation_type: any = "Add";
	validateLendingProductInformation() {
		// if (
		// 	this.lending_product_data.policy_number != '' &&
		// 	this.lending_product_data.policy_number != null
		// ) {
		// 	this.lending_product_data_errors.policy_number = false;
		// } else {
		// 	this.lending_product_data_errors.policy_number = true;
		// }

		if (
			this.lending_product_data.aum != '' &&
			this.lending_product_data.aum != null
		) {
			this.lending_product_data_errors.aum = false;
		} else {
			this.lending_product_data_errors.aum = true;
		}

		if (
			this.lending_product_data.start_date != '' &&
			this.lending_product_data.start_date != null
		) {
			this.lending_product_data_errors.start_date = false;
		} else {
			this.lending_product_data_errors.start_date = true;
		}

		if (
			this.lending_product_data.product != '' &&
			this.lending_product_data.product != null
		) {
			this.lending_product_data_errors.product = false;
		} else {
			this.lending_product_data_errors.product = true;
		}

		if (this.lending_product_data.close_date != "" && this.lending_product_data.close_date != null) {
			this.lending_product_data_errors.close_date = false;
		} else {
			this.lending_product_data_errors.close_date = true;
		}

		if (
			this.lending_product_data.product_type == 'Life Time' ||
			(this.lending_product_data.close_date != '' &&
				this.lending_product_data.close_date != null)
		) {
			this.lending_product_data_errors.close_date = false;
		} else {
			this.lending_product_data_errors.close_date = true;
		}

		// if (
		// 	this.lending_product_data.type != '' &&
		// 	this.lending_product_data.type != null
		// ) {
		// 	this.lending_product_data_errors.type = false;
		// } else {
		// 	this.lending_product_data_errors.type = true;
		// }


		if (
			this.lending_product_data.interest_rate != '' &&
			this.lending_product_data.interest_rate != null
		) {
			this.lending_product_data_errors.interest_rate = false;
		} else {
			this.lending_product_data_errors.interest_rate = true;
		}

		if (
			this.lending_product_data.monthly_fees != '' &&
			this.lending_product_data.monthly_fees != null
		) {
			this.lending_product_data_errors.monthly_fees = false;
		} else {
			this.lending_product_data_errors.monthly_fees = true;
		}

		// if (
		// 	this.lending_product_data.client_product_status != '' &&
		// 	this.lending_product_data.client_product_status != null
		// ) {
		// 	this.lending_product_data_errors.client_product_status = false;
		// } else {
		// 	this.lending_product_data_errors.client_product_status = true;
		// }

		// if (this.user_role == "Relationship Manager") {
		// 	if (
		// 		this.lending_product_data.deposit_purpose != '' &&
		// 		this.lending_product_data.deposit_purpose != null
		// 	) {
		// 		this.lending_product_data_errors.deposit_purpose = false;
		// 	} else {
		// 		this.lending_product_data_errors.deposit_purpose = true;
		// 	}
		// }
		// else {
		// 	this.lending_product_data.deposit_purpose = "";
		// 	this.lending_product_data_errors.deposit_purpose = false;
		// }

		if (
			// this.lending_product_data_errors.policy_number == false &&
			this.lending_product_data_errors.aum == false &&
			this.lending_product_data_errors.start_date == false &&
			this.lending_product_data_errors.product == false &&
			this.lending_product_data_errors.close_date == false &&
			// this.lending_product_data_errors.type == false &&
			// this.lending_product_data_errors.client_product_status == false &&
			this.lending_product_data_errors.interest_rate == false &&
			this.lending_product_data_errors.monthly_fees == false &&
			this.min_amount_error == false
			// this.lending_product_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}

	resetLendingCloseDealData() {
		this.hideDealModal();
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.lending_product_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		this.lending_product_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};
		this.lending_product_operation_type = "Add";
		
		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};
	}

  insurance_product_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',

	};
	insurance_product_data_errors: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',
	};

	insurance_product_operation_type: any = "Add";
	validateInsuranceProductInformation() {
		// if (
		// 	this.insurance_product_data.policy_number != '' &&
		// 	this.insurance_product_data.policy_number != null
		// ) {
		// 	this.insurance_product_data_errors.policy_number = false;
		// } else {
		// 	this.insurance_product_data_errors.policy_number = true;
		// }

		if (
			this.insurance_product_data.aum != '' &&
			this.insurance_product_data.aum != null
		) {
			this.insurance_product_data_errors.aum = false;
		} else {
			this.insurance_product_data_errors.aum = true;
		}

		if (
			this.insurance_product_data.start_date != '' &&
			this.insurance_product_data.start_date != null
		) {
			this.insurance_product_data_errors.start_date = false;
		} else {
			this.insurance_product_data_errors.start_date = true;
		}

		if (
			this.insurance_product_data.product != '' &&
			this.insurance_product_data.product != null
		) {
			this.insurance_product_data_errors.product = false;
		} else {
			this.insurance_product_data_errors.product = true;
		}

		if (this.insurance_product_data.close_date != "" && this.insurance_product_data.close_date != null) {
			this.insurance_product_data_errors.close_date = false;
		} else {
			this.insurance_product_data_errors.close_date = true;
		}

		if (
			this.insurance_product_data.product_type == 'Life Time' ||
			(this.insurance_product_data.close_date != '' &&
				this.insurance_product_data.close_date != null)
		) {
			this.insurance_product_data_errors.close_date = false;
		} else {
			this.insurance_product_data_errors.close_date = true;
		}

		// if (
		// 	this.insurance_product_data.type != '' &&
		// 	this.insurance_product_data.type != null
		// ) {
		// 	this.insurance_product_data_errors.type = false;
		// } else {
		// 	this.insurance_product_data_errors.type = true;
		// }


		if (
			this.insurance_product_data.interest_rate != '' &&
			this.insurance_product_data.interest_rate != null
		) {
			this.insurance_product_data_errors.interest_rate = false;
		} else {
			this.insurance_product_data_errors.interest_rate = true;
		}

		if (
			this.insurance_product_data.monthly_fees != '' &&
			this.insurance_product_data.monthly_fees != null
		) {
			this.insurance_product_data_errors.monthly_fees = false;
		} else {
			this.insurance_product_data_errors.monthly_fees = true;
		}

		// if (
		// 	this.insurance_product_data.client_product_status != '' &&
		// 	this.insurance_product_data.client_product_status != null
		// ) {
		// 	this.insurance_product_data_errors.client_product_status = false;
		// } else {
		// 	this.insurance_product_data_errors.client_product_status = true;
		// }

		// if (this.user_role == "Relationship Manager") {
		// 	if (
		// 		this.insurance_product_data.deposit_purpose != '' &&
		// 		this.insurance_product_data.deposit_purpose != null
		// 	) {
		// 		this.insurance_product_data_errors.deposit_purpose = false;
		// 	} else {
		// 		this.insurance_product_data_errors.deposit_purpose = true;
		// 	}
		// }
		// else {
		// 	this.insurance_product_data.deposit_purpose = "";
		// 	this.insurance_product_data_errors.deposit_purpose = false;
		// }

		if (
			// this.insurance_product_data_errors.policy_number == false &&
			this.insurance_product_data_errors.aum == false &&
			this.insurance_product_data_errors.start_date == false &&
			this.insurance_product_data_errors.product == false &&
			this.insurance_product_data_errors.close_date == false &&
			// this.insurance_product_data_errors.type == false &&
			// this.insurance_product_data_errors.client_product_status == false &&
			this.insurance_product_data_errors.interest_rate == false &&
			this.insurance_product_data_errors.monthly_fees == false &&
			this.min_amount_error == false
			// this.insurance_product_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}

	resetInsuranceCloseDealData() {
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.insurance_product_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		this.insurance_product_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};
		this.insurance_product_operation_type = "Add";
		
		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};
	}


	product_operation_type: any = "Add";
	validateProductInformation() {
		// if (
		// 	this.product_data.policy_number != '' &&
		// 	this.product_data.policy_number != null
		// ) {
		// 	this.product_data_errors.policy_number = false;
		// } else {
		// 	this.product_data_errors.policy_number = true;
		// }

		if (
			this.product_data.aum != '' &&
			this.product_data.aum != null
		) {
			this.product_data_errors.aum = false;
		} else {
			this.product_data_errors.aum = true;
		}

		if (
			this.product_data.start_date != '' &&
			this.product_data.start_date != null
		) {
			this.product_data_errors.start_date = false;
		} else {
			this.product_data_errors.start_date = true;
		}

		if (
			this.product_data.product != '' &&
			this.product_data.product != null
		) {
			this.product_data_errors.product = false;
		} else {
			this.product_data_errors.product = true;
		}

		// if (this.product_data.close_date != "" && this.product_data.close_date != null) {
		//   this.product_data_errors.close_date = false;
		// } else {
		//   this.product_data_errors.close_date = true;
		// }

		if (
			this.product_data.product_type == 'Life Time' ||
			(this.product_data.close_date != '' &&
				this.product_data.close_date != null)
		) {
			this.product_data_errors.close_date = false;
		} else {
			this.product_data_errors.close_date = true;
		}

		// if (
		// 	this.product_data.type != '' &&
		// 	this.product_data.type != null
		// ) {
		// 	this.product_data_errors.type = false;
		// } else {
		// 	this.product_data_errors.type = true;
		// }

		// if (
		// 	this.product_data.client_product_status != '' &&
		// 	this.product_data.client_product_status != null
		// ) {
		// 	this.product_data_errors.client_product_status = false;
		// } else {
		// 	this.product_data_errors.client_product_status = true;
		// }

		if (this.user_role == "Relationship Manager") {
			if (
				this.product_data.deposit_purpose != '' &&
				this.product_data.deposit_purpose != null
			) {
				this.product_data_errors.deposit_purpose = false;
			} else {
				this.product_data_errors.deposit_purpose = true;
			}
		} else {
			this.product_data.deposit_purpose = "";
			this.product_data_errors.deposit_purpose = false;
		}

		if (
			// this.product_data_errors.policy_number == false &&
			this.product_data_errors.aum == false &&
			this.product_data_errors.start_date == false &&
			this.product_data_errors.product == false &&
			this.product_data_errors.close_date == false &&
			// this.product_data_errors.type == false &&
			// this.product_data_errors.client_product_status == false &&
			this.product_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}

	saveProductInformation() {
		let payload: any;
		if (this.user_details.role.business_area[0] == '5') {
			payload = {
				product: this.product_data.product,
				policy_number: this.product_data.policy_number,
				aum: this.product_data.aum == '' ? 0 : this.product_data.aum,
				start_date: moment(this.product_data.start_date).format(),
				close_date: this.product_data.close_date != '' ? moment(this.product_data.close_date).format() : null,
				// client: this.selected_user_data.id,
				// client: this.activities[this.show_inner_view].client,
				type: this.product_data.type,
				deposit_purpose: this.product_data.deposit_purpose,
			};
    	}

		if (this.user_details.role.business_area[0] == '6') {
			payload = {
				product: this.depositProduct_data.product,
				policy_number: this.depositProduct_data.policy_number,
				aum: this.depositProduct_data.aum == '' ? 0 : this.depositProduct_data.aum,
				start_date: moment(this.depositProduct_data.start_date).format(),
				close_date: this.depositProduct_data.close_date != '' ? moment(this.depositProduct_data.close_date).format() : null,
				// client: this.selected_user_data.id,
				// client: this.activities[this.show_inner_view].client,
				type: this.depositProduct_data.type,
				deposit_purpose: this.depositProduct_data.deposit_purpose,
				interest_rate: this.depositProduct_data.interest_rate,
				monthly_fees: this.depositProduct_data.monthly_fees,

			};
    	}

    	if (this.user_details.role.business_area[0] == '7') {
			payload = {
				product: this.lending_product_data.product,
				policy_number: this.lending_product_data.policy_number,
				aum: this.lending_product_data.aum == '' ? 0 : this.lending_product_data.aum,
				start_date: moment(this.lending_product_data.start_date).format(),
				close_date: this.lending_product_data.close_date != '' ? moment(this.lending_product_data.close_date).format() : null,
				// client: this.selected_user_data.id,
				// client: this.activities[this.show_inner_view].client,
				type: this.lending_product_data.type,
				deposit_purpose: this.lending_product_data.deposit_purpose,
				interest_rate: this.lending_product_data.interest_rate,
				monthly_fees: this.lending_product_data.monthly_fees,

			};
    	}

    	if (this.user_details.role.business_area[0] == '8') {
			payload = {
				product: this.insurance_product_data.product,
				policy_number: this.insurance_product_data.policy_number,
				aum: this.insurance_product_data.aum == '' ? 0 : this.insurance_product_data.aum,
				start_date: moment(this.insurance_product_data.start_date).format(),
				close_date: this.insurance_product_data.close_date != '' ? moment(this.insurance_product_data.close_date).format() : null,
				// client: this.selected_user_data.id,
				// client: this.activities[this.show_inner_view].client,
				type: this.insurance_product_data.type,
				deposit_purpose: this.insurance_product_data.deposit_purpose,
				interest_rate: this.insurance_product_data.interest_rate,
				monthly_fees: this.insurance_product_data.monthly_fees,

			};
    	}

		// if (this.stepper_stage) {
		// 	payload.stepper_type = this.stepper_stage.type;
		// } else {
		// 	payload.stepper_type = this.data.type;
		// }

		if (this.product_operation_type == "Add" || this.depositProduct_operation_type == "Add") {
			let route: any = "";
			if (this.activity_data) {
				if (this.activity_data.source == 'csa') {
					route = "/addclientinvestedproducts/";
					payload.client = this.activity_data.client;
				} else if (this.activity_data.source == 'lpa') {
					route = "/addprospectinvestedproducts/";
					payload.prospect = this.activity_data.prospect_id;
				}
			} else {
				if ('is_client' in this.activity_data) {
					route = "/addprospectinvestedproducts/";
					payload.prospect = this.activity_data.prospect_id;
				} else {
					route = "/addclientinvestedproducts/";
					payload.client = this.activity_data.client;
				}
			}
			this.commonService.postData(route, payload).subscribe(
				(res: any) => {
					this.resetCloseDealData();
					this.resetDepositCloseDealData();
					this.resetLendingCloseDealData();
					this.resetInsuranceCloseDealData();
					// this.close();
					// this.commonService.showToast('success', 'Product Added Successfully.',);
					this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);

					if (this.closeDealModalRef) {
						this.hideDealModal();
						// this.close();
						this.getActivityData();
					}

					if (this.changeOutcomeModalRef) {
						this.closeChangeOutcomeModal();
						// this.close();
						this.getActivityData();
					}
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else if (this.product_operation_type == "Edit" || this.depositProduct_data == "Edit") {
			if (this.user_details.role.business_area[0] == '5') {
				payload.id = this.product_data.id;
			} else if (this.user_details.role.business_area[0] == '6') {
				payload.id = this.depositProduct_data.id;
			} else if (this.user_details.role.business_area[0] == '7') {
				payload.id = this.lending_product_data.id;
			} else if (this.user_details.role.business_area[0] == '8') {
				payload.id = this.insurance_product_data.id;
			}
			let route: any = "";
			if (this.activity_data.source == 'csa') {
				route = "/clientproducts/";
			} else if (this.activity_data.source == 'lpa') {
				route = "/prospectinvestedproducts/";
			}
			this.commonService.updateData(route + payload.id + '/', payload).subscribe(
				(res: any) => {
					this.resetCloseDealData();
					this.resetDepositCloseDealData();
					this.resetLendingCloseDealData();
					this.resetInsuranceCloseDealData();
					// this.close();
					// this.commonService.showToast('success', 'Product Updated Successfully.', );
					this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);

					if (this.closeDealModalRef) {
						this.hideDealModal();
						// this.close();
						this.getActivityData();
					}

					if (this.changeOutcomeModalRef) {
						this.closeChangeOutcomeModal();
						// this.close();
						this.getActivityData();
					}
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	min_amount_error: boolean = false;
	min_amount_error_text: any = "";
	checkAmountValidation(product, amount) {
		if (product != "" && product != null) {
			const index = this.products_list.findIndex((x) => x.id == product);

			if (index != -1) {
				const product = this.products_list[index];

				const product_min_amount = parseInt(product.min_balance_required);
				let aum: any = 0;
				if (amount != "" && amount != null) {
					aum = parseInt(amount);
				} else {
					aum = 0;
				}

				if (product_min_amount > aum) {
					this.min_amount_error = true;
					this.min_amount_error_text = "Amount Should be Greater than or Equal to " + product_min_amount;
				} else {
					this.min_amount_error = false;
					this.min_amount_error_text = "";
				}
			} else {
				this.min_amount_error = false;
				this.min_amount_error_text = "";
			}

		}
	}

	validateMaxValue(event, max_value): boolean {
		const charCode = event.which ? event.which : event.keyCode;

		// Allow only numeric input and the decimal point
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}

		// Get the current value of the input field
		const inputElement = event.target as HTMLInputElement;
		const currentValue = inputElement.value;

		// Check if the input value, when modified, would exceed 100
		const newValue = currentValue + String.fromCharCode(charCode);

		if (newValue !== '.' && parseFloat(newValue) > max_value) {
			return false;
		}

		return true;
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

	@ViewChild('changeOutcomeModal') changeOutcomeModal: TemplateRef<any>;
	private changeOutcomeModalRef: MatDialogRef<TemplateRef<any>>;

	openChangeOutcomeModal() {
		this.changeOutcomeModalRef = this.dialog.open(this.changeOutcomeModal, { disableClose: true });
		this.changeOutcomeModalRef.afterClosed().subscribe((result) => {
			this.closeChangeOutcomeModal();
		});
	}

	closeChangeOutcomeModal() {
		this.changeOutcomeModalRef.close();
		this.hideChangeOutcomeView();
	}

	hideChangeOutcomeView() {
		// this.show_change_outcome_view = false;
		this.resetCloseDealData();
		this.resetDepositCloseDealData();
		this.resetLendingCloseDealData();
    	this.resetInsuranceCloseDealData();
	}

	// Change Outcome Code
	outcome_data: any = {
		attrition_status: '',
		attrition_comments: '',
	};
	outcome_data_errors: any = {
		attrition_status: false,
		attrition_comments: false,
	};

	validateOutcomeStatus() {
		if (
			this.outcome_data.attrition_status != '' &&
			this.outcome_data.attrition_status != null
		) {
			this.outcome_data_errors.attrition_status = false;
		} else {
			this.outcome_data_errors.attrition_status = true;
		}

		if (
			this.outcome_data.attrition_comments != '' &&
			this.outcome_data.attrition_comments != null
		) {
			this.outcome_data_errors.attrition_comments = false;
		} else {
			this.outcome_data_errors.attrition_comments = true;
		}

		if (
			this.outcome_data_errors.attrition_status == false &&
			this.outcome_data_errors.attrition_comments == false
		) {
			if (this.outcome_data.attrition_status == 'Retained, Upside') {
				this.validateProductInformation();
				return true;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}

	saveOutcomeStatusData(data) {
		let payload: any = {
			attrition_status: this.outcome_data.attrition_status,
			attrition_comments: this.outcome_data.attrition_comments,
			// client_id: this.selected_user_data.id,
			client_id: this.activity_data.client,
		};

		if (!data) {
			payload.id = "";
		} else {
			if (data.source == 'csa') {
				payload.csa_id = data.id;
			} else if (data.source == 'lpa') {
				payload.lpa_id = data.id;
			} else if (data.source == 'ama') {
				payload.ama_id = data.id;
			}
		}

		// if (this.stepper_stage) {
		// 	payload.stepper_type = this.stepper_stage.type;
		// }

		this.commonService.postData('/clientattritionoutcome/', payload).subscribe(
			(res: any) => {
				if (this.outcome_data.attrition_status != 'Retained, Upside') {
					this.resetCloseDealData();
					this.resetDepositCloseDealData();
					this.resetLendingCloseDealData();
          			this.resetInsuranceCloseDealData();
					// this.close();
					this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);

					if (this.closeDealModalRef) {
						this.hideDealModal();
						// this.close();
						this.getActivityData();
					}

					if (this.changeOutcomeModalRef) {
						this.closeChangeOutcomeModal();
						// this.close();
						this.getActivityData();
					}

				} else {
					this.saveProductInformation();
				}
				// this.commonService.showToast('success', 'Outcome Changed Successfully.',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	addOutcome() {
		if (this.validateOutcomeStatus()) {
			if (this.outcome_data.attrition_status == 'Retained, Upside') {
				// if (this.validateProductInformation()) {
				// 	this.saveOutcomeStatusData(this.activity_data);
				// 	// this.saveProductInformation();
				// }

				if (this.user_details.role.business_area[0] == '5') {
					if (this.validateProductInformation()) {
						this.saveOutcomeStatusData(this.activity_data);
					}
				}
				if (this.user_details.role.business_area[0] == '6') {
					if (this.validateDepositProductInformation()) {
						this.saveOutcomeStatusData(this.activity_data);
					}
				}

				if (this.user_details.role.business_area[0] == '7') {
					if (this.validateLendingProductInformation()) {
						this.saveOutcomeStatusData(this.activity_data);
					}
				}

				if (this.user_details.role.business_area[0] == '8') {
					if (this.validateInsuranceProductInformation()) {
						this.saveOutcomeStatusData(this.activity_data);
					}
				}

			} else {
				this.saveOutcomeStatusData(this.activity_data);
			}
		}
	}

	capture_results_data: any = {
		appointment_status_id: "",
		appointment_comments: "",
	};
	capture_results_data_errors: any = {
		appointment_status_id: false,
		appointment_comments: false,
	};
	@ViewChild('captureresultsModal') captureresultsModal: TemplateRef<any>;
	private captureresultsModalRef: MatDialogRef<TemplateRef<any>>;

	move_record_stage_activity_status: boolean = true;

	openCaptureresultsModal() {
		this.captureresultsModalRef = this.dialog.open(this.captureresultsModal, { disableClose: true });
		this.captureresultsModalRef.afterClosed().subscribe((result) => {
			this.hideCaptureresultsModal();
		});
	}

	hideCaptureresultsModal() {
		this.captureresultsModalRef.close();
		this.move_record_stage_activity_status = false;
		this.capture_results_data = {
			appointment_status_id: "",
			appointment_comments: "",
		};
		this.capture_results_data_errors = {
			appointment_status_id: false,
			appointment_comments: false,
		};
	}

	saveCaptureResultsData() {
		if (this.capture_results_data.appointment_status_id != "" && this.capture_results_data.appointment_status_id != null) {
			this.capture_results_data_errors.appointment_status_id = false;
		} else {
			this.capture_results_data_errors.appointment_status_id = true;
		}

		if (this.capture_results_data.appointment_comments != "" && this.capture_results_data.appointment_comments != null) {
			this.capture_results_data_errors.appointment_comments = false;
		} else {
			this.capture_results_data_errors.appointment_comments = true;
		}

		if (
			this.capture_results_data_errors.appointment_status_id == false &&
			this.capture_results_data_errors.appointment_comments == false
		) {
			let payload: any = {
				appointment_status_id: this.capture_results_data.appointment_status_id,
				appointment_comments: this.capture_results_data.appointment_comments,
				advisor_list: [],
				not_required: this.move_record_stage_activity_status,
			};


			// this.commonService.postData("/wholesalerresults", payload).subscribe(
			this.commonService.postData("/recruiterresults", payload).subscribe(
			(res: any) => {
				this.commonService.showToast('success', 'Advisor moved to next stage; activities no longer visible upon deal closer');
				this.hideCaptureresultsModal();
				// this.close();
				this.getActivityData();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

		}

	}

	activityQuickAction() {
		if (this.activity_data.action_type == "Email") {
			this.openEmail(this.activity_data);
		} else if (this.activity_data.action_type == "Phone") {
			const telLink = `tel:${this.activity_data.action_value}`;
    		window.open(telLink, '_blank');
		} else if (this.activity_data.action_type == "Meeting") {
			window.open(this.activity_data.action_value, "_blank")
		}
	}

	openEmail(email) {
		// const email_data = JSON.parse(JSON.stringify(email));
		// const parser = new DOMParser();
		// const html = parser.parseFromString(email_data.email_body, 'text/html');
		// window.open('mailto:' + email.email + '?subject=' + email.subject + '&body=' + encodeURIComponent(html.body.innerText), '_blank',);

		const recipient = email.email;
		const subject = email.subject;
		// const body = email.email_body;

		let body = email.email_body;
		const maxLength = 1250; // Example limit, adjust as needed
		body = this.convertHtmlToText(body)

		if (body.length > maxLength) {
			body = body.substring(0, maxLength) + '...';
		}

		const encodedSubject = encodeURIComponent(subject);
		const encodedBody = encodeURIComponent(body);
		const mailtoLink = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`;
		window.open(mailtoLink, '_blank');

	}

	convertHtmlToText(htmlContent: string): string {
		const parser = new DOMParser();
		const doc = parser.parseFromString(htmlContent, 'text/html');

		// Extract text content and replace list items and newlines
		let textContent = doc.body.innerHTML;
		let firstParagraph = true;
		// textContent = textContent.replace(/<p class="MsoNormal"><span lang="EN-US">/g, match => {
		//   if (firstParagraph) {
		// 	firstParagraph = false;
		// 	return ''; // Replace the first occurrence with an empty string
		//   } else {
		// 	return '\n'; // Replace subsequent occurrences with a newline
		//   }
		// });

		textContent = textContent.replace(/<p[^>]*>(.*?)<\/p>/g, (match, content) => {
			content = content.trim();
			if (!content) {
				return ''; // Ignore empty paragraphs
			}

			if (firstParagraph) {
				firstParagraph = false;
				return content; // No new line for the first paragraph
			} else {
				return '\n' + content; // New line before subsequent paragraphs
			}
		});

		// Convert <li> to bullet points
		textContent = textContent.replace(/<li[^>]*>/g, '\n• ').replace(/<\/li>/g, '');
		textContent = textContent.replace(/<p[^>]*>|<br[^>]*>/g, '\n').replace(/<\/p>/g, '');

		// Remove all other HTML tags
		textContent = textContent.replace(/<[^>]+>/g, '');

		// Replace special characters for mailto link compatibility
		textContent = textContent.replace(/&#8217;/g, "'")   // Replace right single quote
			.replace(/&amp;/g, "&")    // Replace ampersand
			.replace(/&nbsp;/g, " ")   // Replace non-breaking spaces
			.replace(/%/g, '%')      // URL encode %
			.replace(/&/g, '&')      // URL encode &
			.replace(/\n\n/g, '');    // Encode newline for mailto

		textContent = textContent
			.split('\n') // Split by newlines
			.map(line => line.replace(/\s+/g, ' ').trim()) // Process each line to replace multiple spaces with single space
			.join('\n');

		return textContent
	}

	@ViewChild('activityEmailPreviewModal') activityEmailPreviewModal: TemplateRef<any>;
	private activityEmailPreviewModalRef: MatDialogRef<TemplateRef<any>>;
	activity_email_data: any;
	activity_email_data_loaded: boolean = false;
	openActivityEmailPreviewModal(activity) {
		if ((activity.activity_type == 1) || (activity.activity_type == 4) || (activity.activity_type == 5)) {
			this.activity_email_data_loaded = false;

			this.activityEmailPreviewModalRef = this.dialog.open(this.activityEmailPreviewModal, { disableClose: true });
			this.activityEmailPreviewModalRef.afterClosed().subscribe((result) => {
				this.closeActivityEmailPreviewModal();
			});

			this.commonService.getData("/emailTemplate/" + activity.email_template).subscribe(
				(res: any) => {
					this.activity_email_data = res;
					this.activity_email_data_loaded = true;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else {
            if (activity.source == 'lpa'){
                if ((activity.activity_type == 3)) {
                    this.activity_email_data_loaded = false;

                    this.activityEmailPreviewModalRef = this.dialog.open(this.activityEmailPreviewModal, { disableClose: true });
                    this.activityEmailPreviewModalRef.afterClosed().subscribe((result) => {
                        this.closeActivityEmailPreviewModal();
                    });

                    this.commonService.getData("/emailTemplate/" + activity.email_template).subscribe(
                        (res: any) => {
                            this.activity_email_data = res;
                            this.activity_email_data_loaded = true;
                        },
                        (err) => {
                            this.commonService.showToast('error', err.error);
                        },
                    );
                }
            }
        }

	}

	closeActivityEmailPreviewModal() {
		this.activityEmailPreviewModalRef.close();
		this.activity_email_data = {};
		this.activity_email_data_loaded = false;
	}

	getHTML(html) {
		return this.domSanitizer.bypassSecurityTrustHtml(html);
	}


}